import React from 'react'
import Answer from './Answer'

function Answers({answerOptions, answered, userQuestionId, changeAnswer}) {

  return (
  <div className='answer-pane'>
    {answerOptions.map(answer=><Answer key={answer._id} answer={answer} answered={answered}  userQuestionId={userQuestionId} changeAnswer ={changeAnswer}  /> )}
    </div>)
}

export default Answers